// Eingabe für den sechsstelligen Code aus der Authenticator-App.
//
// Ein einziges Feld statt sechs Kästchen: So funktionieren Einfügen,
// Passwortmanager und das Code-Angebot der Handy-Tastatur (autocomplete=
// one-time-code) ohne Kunstgriffe. Die Optik mit großen, gesperrten Ziffern
// macht trotzdem klar, dass hier sechs Zeichen hingehören.
//
// `wiederherstellung`: stattdessen ein Wiederherstellungscode (K7F2-9QXA).

import { forwardRef, type ChangeEvent } from "react";

export const CodeFeld = forwardRef<HTMLInputElement, {
  value: string;
  onChange: (v: string) => void;
  wiederherstellung?: boolean;
  autoFocus?: boolean;
  id?: string;
  label?: string;
}>(function CodeFeld({ value, onChange, wiederherstellung = false, autoFocus, id, label }, ref) {
  return (
    <input
      ref={ref}
      id={id}
      aria-label={label ?? (wiederherstellung ? "Wiederherstellungscode" : "Sechsstelliger Code")}
      className="input text-center font-mono text-2xl font-semibold tracking-[0.35em] placeholder:tracking-[0.35em] placeholder:text-muted/50"
      style={{ height: "3.25rem" }}
      value={value}
      autoFocus={autoFocus}
      required
      {...(wiederherstellung
        ? {
            inputMode: "text" as const,
            autoComplete: "off",
            autoCapitalize: "characters",
            spellCheck: false,
            maxLength: 9,
            placeholder: "XXXX-XXXX",
            onChange: (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value.toUpperCase()),
          }
        : {
            inputMode: "numeric" as const,
            autoComplete: "one-time-code",
            pattern: "[0-9]{6}",
            maxLength: 7,
            placeholder: "000000",
            // Nur Ziffern – eingefügte Leerzeichen („123 456“) fallen weg.
            onChange: (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value.replace(/\D/g, "").slice(0, 6)),
          })}
    />
  );
});
